import { render } from "./goodsItem.vue?vue&type=template&id=4a03b701&scoped=true"
import script from "./goodsItem.vue?vue&type=script&lang=js"
export * from "./goodsItem.vue?vue&type=script&lang=js"

import "./goodsItem.vue?vue&type=style&index=0&id=4a03b701&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a03b701"]])

export default __exports__